// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rosario&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  overflow-x: hidden;
  overflow-x: clip;
  font-family: Rosario;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  max-width: 100%;
  overflow-x: hidden;
  overflow-x: clip;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

html.native-app {
  --safe-area-top: env(safe-area-inset-top, 0px);
  --safe-area-right: env(safe-area-inset-right, 0px);
  --safe-area-bottom: env(safe-area-inset-bottom, 0px);
  --safe-area-left: env(safe-area-inset-left, 0px);
  --native-comfort-x: 6px;
  --native-keyboard-height: 0px;
  --native-viewport-height: 100dvh;
  scroll-padding-top: calc(var(--safe-area-top) + 76px);
  scroll-padding-bottom: calc(var(--safe-area-bottom) + 92px);
}

html.native-app body {
  min-height: 100dvh;
  overscroll-behavior-y: none;
  -webkit-tap-highlight-color: transparent;
}

html.native-app #root {
  box-sizing: border-box;
  min-height: 100dvh;
  padding-left: var(--safe-area-left);
  padding-right: var(--safe-area-right);
}

html.native-app.native-keyboard-open {
  scroll-padding-bottom: 24px;
}

html.native-app.native-keyboard-open body {
  height: var(--native-viewport-height);
  min-height: var(--native-viewport-height);
  overflow: hidden;
}

html.native-app.native-keyboard-open #root {
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

html.native-app.native-keyboard-open .login-page,
html.native-app.native-keyboard-open .register-page {
  box-sizing: border-box;
  height: var(--native-viewport-height);
  min-height: var(--native-viewport-height);
  justify-content: flex-start;
  overflow-y: auto;
  padding-top: 18px;
  padding-bottom: 24px;
}

html.native-app.native-keyboard-open .ig-chat-layout.chat-open,
html.native-app.native-keyboard-open .pv-overlay,
html.native-app.native-keyboard-open .modal-overlay,
html.native-app.native-keyboard-open .comment-overlay {
  height: var(--native-viewport-height) !important;
  max-height: var(--native-viewport-height) !important;
  min-height: 0 !important;
  top: 0 !important;
  bottom: auto !important;
}

html.native-app.native-keyboard-open .ig-chat-layout.chat-open .ig-chat-panel,
html.native-app.native-keyboard-open .pv-modal {
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
}

html.native-app.native-keyboard-open .pv-modal {
  grid-template-rows: minmax(0, 34%) minmax(0, 66%) !important;
}

html.native-app.native-keyboard-open .chat-input,
html.native-app.native-keyboard-open .comment-input {
  position: relative;
  z-index: 30;
  flex: 0 0 auto;
  padding-bottom: 10px !important;
  background: #ffffff;
}

html.native-app.native-keyboard-open .mobile-bottom-nav,
html.native-app.native-keyboard-open .bottom-nav,
html.native-app.native-keyboard-open .mobile-nav {
  visibility: hidden !important;
  pointer-events: none !important;
}

html.native-app input:focus,
html.native-app textarea:focus,
html.native-app select:focus,
html.native-app [contenteditable="true"]:focus {
  scroll-margin-top: calc(var(--safe-area-top) + 88px);
  scroll-margin-bottom: 32px;
}

html.native-app button,
html.native-app a,
html.native-app input,
html.native-app textarea,
html.native-app select {
  touch-action: manipulation;
}

/*
 * Prevent iOS browsers from zooming the viewport when a form control receives
 * focus. Kept mobile-only so desktop sizing remains unchanged everywhere.
 */
@media (max-width: 768px) {
  input:not([type="checkbox"]):not([type="radio"]):not([type="range"]),
  select,
  textarea {
    font-size: 16px !important;
  }

  /*
   * Keep native dropdowns inside the viewport on iPhone and small Android
   * screens. Native appearance is preserved so iOS can use its accessible
   * bottom-sheet picker.
   */
  select {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 48px;
    padding-inline: 12px 38px;
    line-height: 1.25;
    text-overflow: ellipsis;
    white-space: nowrap;
    touch-action: manipulation;
  }

  select option {
    max-width: 100vw;
    font-size: 16px;
  }
}
.comment-username-link {
  cursor: pointer;
  transition: color .18s ease;
}

.comment-username-link:hover {
  color: #e95a13;
  text-decoration: underline;
  text-underline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,8CAA8C;EAC9C,kDAAkD;EAClD,oDAAoD;EACpD,gDAAgD;EAChD,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,qDAAqD;EACrD,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,sBAAsB;EACtB,qCAAqC;EACrC,yCAAyC;EACzC,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;EAIE,gDAAgD;EAChD,oDAAoD;EACpD,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;;EAGE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;;;;EAIE,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA;;;;;EAKE,0BAA0B;AAC5B;;AAEA;;;EAGE;AACF;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;;;;IAIE;EACF;IACE,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Rosario&display=swap');\nbody {\n  margin: 0;\n  overflow-x: hidden;\n  overflow-x: clip;\n  font-family: Rosario;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml {\n  max-width: 100%;\n  overflow-x: hidden;\n  overflow-x: clip;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nhtml.native-app {\n  --safe-area-top: env(safe-area-inset-top, 0px);\n  --safe-area-right: env(safe-area-inset-right, 0px);\n  --safe-area-bottom: env(safe-area-inset-bottom, 0px);\n  --safe-area-left: env(safe-area-inset-left, 0px);\n  --native-comfort-x: 6px;\n  --native-keyboard-height: 0px;\n  --native-viewport-height: 100dvh;\n  scroll-padding-top: calc(var(--safe-area-top) + 76px);\n  scroll-padding-bottom: calc(var(--safe-area-bottom) + 92px);\n}\n\nhtml.native-app body {\n  min-height: 100dvh;\n  overscroll-behavior-y: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\nhtml.native-app #root {\n  box-sizing: border-box;\n  min-height: 100dvh;\n  padding-left: var(--safe-area-left);\n  padding-right: var(--safe-area-right);\n}\n\nhtml.native-app.native-keyboard-open {\n  scroll-padding-bottom: 24px;\n}\n\nhtml.native-app.native-keyboard-open body {\n  height: var(--native-viewport-height);\n  min-height: var(--native-viewport-height);\n  overflow: hidden;\n}\n\nhtml.native-app.native-keyboard-open #root {\n  height: 100%;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\nhtml.native-app.native-keyboard-open .login-page,\nhtml.native-app.native-keyboard-open .register-page {\n  box-sizing: border-box;\n  height: var(--native-viewport-height);\n  min-height: var(--native-viewport-height);\n  justify-content: flex-start;\n  overflow-y: auto;\n  padding-top: 18px;\n  padding-bottom: 24px;\n}\n\nhtml.native-app.native-keyboard-open .ig-chat-layout.chat-open,\nhtml.native-app.native-keyboard-open .pv-overlay,\nhtml.native-app.native-keyboard-open .modal-overlay,\nhtml.native-app.native-keyboard-open .comment-overlay {\n  height: var(--native-viewport-height) !important;\n  max-height: var(--native-viewport-height) !important;\n  min-height: 0 !important;\n  top: 0 !important;\n  bottom: auto !important;\n}\n\nhtml.native-app.native-keyboard-open .ig-chat-layout.chat-open .ig-chat-panel,\nhtml.native-app.native-keyboard-open .pv-modal {\n  height: 100% !important;\n  min-height: 0 !important;\n  max-height: 100% !important;\n}\n\nhtml.native-app.native-keyboard-open .pv-modal {\n  grid-template-rows: minmax(0, 34%) minmax(0, 66%) !important;\n}\n\nhtml.native-app.native-keyboard-open .chat-input,\nhtml.native-app.native-keyboard-open .comment-input {\n  position: relative;\n  z-index: 30;\n  flex: 0 0 auto;\n  padding-bottom: 10px !important;\n  background: #ffffff;\n}\n\nhtml.native-app.native-keyboard-open .mobile-bottom-nav,\nhtml.native-app.native-keyboard-open .bottom-nav,\nhtml.native-app.native-keyboard-open .mobile-nav {\n  visibility: hidden !important;\n  pointer-events: none !important;\n}\n\nhtml.native-app input:focus,\nhtml.native-app textarea:focus,\nhtml.native-app select:focus,\nhtml.native-app [contenteditable=\"true\"]:focus {\n  scroll-margin-top: calc(var(--safe-area-top) + 88px);\n  scroll-margin-bottom: 32px;\n}\n\nhtml.native-app button,\nhtml.native-app a,\nhtml.native-app input,\nhtml.native-app textarea,\nhtml.native-app select {\n  touch-action: manipulation;\n}\n\n/*\n * Prevent iOS browsers from zooming the viewport when a form control receives\n * focus. Kept mobile-only so desktop sizing remains unchanged everywhere.\n */\n@media (max-width: 768px) {\n  input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]),\n  select,\n  textarea {\n    font-size: 16px !important;\n  }\n\n  /*\n   * Keep native dropdowns inside the viewport on iPhone and small Android\n   * screens. Native appearance is preserved so iOS can use its accessible\n   * bottom-sheet picker.\n   */\n  select {\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    min-height: 48px;\n    padding-inline: 12px 38px;\n    line-height: 1.25;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    touch-action: manipulation;\n  }\n\n  select option {\n    max-width: 100vw;\n    font-size: 16px;\n  }\n}\n.comment-username-link {\n  cursor: pointer;\n  transition: color .18s ease;\n}\n\n.comment-username-link:hover {\n  color: #e95a13;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
